import { MessageBar, MessageBarActions, MessageBarBody } from '@fluentui/react-components';
import { Warning20Filled } from '@fluentui/react-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../Button';
import './NotCheckedAbsencesNotification.scss';

export interface NotCheckedAbsencesNotificationProps {
  onMarkAllAsPresentClick: () => void;
  onCheckAbsencesClick: () => void;
  disabled?: boolean;
  isEditable?: boolean;
}

/**
 * Notification banner that is displayed in the course book if the current
 * attendance has not yet been checked.
 */
export const NotCheckedAbsencesNotification: React.FC<NotCheckedAbsencesNotificationProps> = (
  props,
) => {
  const { t } = useTranslation();

  return (
    <MessageBar
      intent="error"
      role="alert"
      className="notConfirmedAbsencesAlert"
      icon={{ children: <Warning20Filled />, className: 'notConfirmedAbsencesIcon' }}
    >
      <MessageBarBody>
        <strong>
          {t('classbook:absences:not_checked_notification', {
            defaultValue: 'Anwesenheitsprüfung unvollständig',
          })}
        </strong>
      </MessageBarBody>
      {props.isEditable && (
        <MessageBarActions>
          <Button size="medium" onClick={props.onMarkAllAsPresentClick} disabled={props.disabled}>
            {t('classbook:absences:notification_all_present', {
              defaultValue: 'Alle Anwesend',
            })}
          </Button>
          <Button size="medium" onClick={props.onCheckAbsencesClick}>
            {t('classbook:absences:notification_check_now', {
              defaultValue: 'Jetzt prüfen',
            })}
          </Button>
        </MessageBarActions>
      )}
    </MessageBar>
  );
};
